/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortObject } from './sortObject';


export interface PageableObject { 
    offset?: number;
    paged?: boolean;
    pageNumber?: number;
    pageSize?: number;
    sort?: SortObject;
    unpaged?: boolean;
}

